(() => {
  if (window.hrProductCopyLoaded) return;
  window.hrProductCopyLoaded = true;
  const segmenter = typeof Intl.Segmenter === 'function' ? new Intl.Segmenter('en', {granularity:'sentence'}) : null;
  function formatCopy(root) {
    if (root.dataset.hrFormatted) return;
    root.dataset.hrFormatted = 'true';
    for (const el of root.querySelectorAll('[style],font')) {
      const weight = parseInt(el.style.fontWeight, 10);
      if (weight >= 600 && el.closest('p')?.textContent.trim() === el.textContent.trim()) el.dataset.hrHeading = 'true';
      for (const property of ['font-family','font-size','line-height','letter-spacing','text-align','text-transform','font-weight']) el.style.removeProperty(property);
      for (const attribute of ['face','size','color']) el.removeAttribute(attribute);
    }
    for (const p of [...root.querySelectorAll('p')]) {
      if (p.querySelector('img,video,iframe,table,a') || p.closest('table')) continue;
      const pieces = p.innerHTML.split(/<br\s*\/?\s*>/i);
      const replacement = document.createDocumentFragment();
      let list = null;
      for (const html of pieces) {
        const part = document.createElement('div');
        part.innerHTML = html;
        const text = part.textContent.trim();
        if (!text) continue;
        if (/^[·•]\s*/.test(text)) {
          if (!list) {list=document.createElement('ul');replacement.append(list);}
          const walker=document.createTreeWalker(part,NodeFilter.SHOW_TEXT);
          let node;
          while ((node=walker.nextNode())) {
            if (node.textContent.trim()) {node.textContent=node.textContent.replace(/^\s*[·•]\s*/,'');break;}
          }
          const li=document.createElement('li');
          while(part.firstChild) li.append(part.firstChild);
          list.append(li);
          continue;
        }
        list=null;
        const strong=part.querySelector('strong,b,[data-hr-heading]');
        if (text.length<160 && ((strong && strong.textContent.trim()===text) || text.endsWith(':'))) {
          const h=document.createElement('h3');h.textContent=text;replacement.append(h);continue;
        }
        if (text.length>280 && segmenter && !part.querySelector('strong,b,em,i')) {
          const sentences=[];
          for (const entry of segmenter.segment(text)) {
            let sentence=entry.segment;
            const marker=sentence.match(/^\s*[†‡]+/);
            if (marker && sentences.length) {
              sentences[sentences.length-1]=sentences[sentences.length-1].trimEnd()+marker[0].trim()+' ';
              sentence=sentence.slice(marker[0].length);
            }
            if(sentence.trim()) sentences.push(sentence);
          }
          let group='';
          for(const sentence of sentences) {
            if(group && group.length+sentence.length>250) {
              const paragraph=document.createElement('p');paragraph.textContent=group.trim();replacement.append(paragraph);group='';
            }
            group+=sentence;
          }
          if(group.trim()) {const paragraph=document.createElement('p');paragraph.textContent=group.trim();replacement.append(paragraph);}
        } else {
          const paragraph=document.createElement('p');
          while(part.firstChild) paragraph.append(part.firstChild);
          replacement.append(paragraph);
        }
      }
      p.replaceWith(replacement);
    }
    for (const list of [...root.querySelectorAll('ul')]) {
      while (list.nextElementSibling?.tagName === 'UL') {
        const next = list.nextElementSibling;
        while (next.firstChild) list.append(next.firstChild);
        next.remove();
      }
    }
  }
  function run() {document.querySelectorAll('.hr-product-copy').forEach(formatCopy);}
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run,{once:true});else run();
  document.addEventListener('shopify:section:load',run);
})();
